"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TriangleSemifill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TriangleSemifill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.138 2.32.938 1.631-4.41 4.41 3.472-6.042ZM2 13h2.351l6.303-6.303-.986-1.716-7.193 7.193L2 13ZM8.676 13H5.973l5.273-5.273.986 1.716L8.677 13ZM10.297 13H13l.81-.81-.986-1.717L10.297 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.726 15H4.274c-1.9 0-2.85 0-3.403-.407a2.164 2.164 0 0 1-.863-1.506c-.076-.692.39-1.536 1.32-3.226l3.727-6.759C6.018 1.355 6.499.482 7.132.19a2.074 2.074 0 0 1 1.736 0c.633.291 1.114 1.165 2.077 2.912l3.727 6.76c.93 1.689 1.396 2.533 1.32 3.225a2.164 2.164 0 0 1-.863 1.506c-.554.407-1.503.407-3.403.407ZM10.07 3.585l3.726 6.76c.475.86.797 1.447.998 1.905.202.46.213.647.204.727-.037.33-.207.623-.462.81-.054.04-.207.12-.697.166-.486.046-1.143.047-2.113.047H4.274c-.97 0-1.627-.001-2.113-.047-.49-.045-.643-.126-.697-.166a1.164 1.164 0 0 1-.462-.81c-.009-.08.002-.266.204-.727.2-.457.523-1.044.998-1.906l3.726-6.76c.491-.89.827-1.497 1.116-1.924.293-.433.444-.534.504-.561.287-.132.613-.132.9 0 .06.027.211.128.504.561.289.427.625 1.034 1.116 1.925Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TriangleSemifill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TriangleSemifill;
exports["default"] = _default;